export function getDescriptorName(
  descriptor: { readonly id: string; readonly name?: string },
  builtInIds: Record<string, string>,
): string | undefined {
  return descriptor.name ?? (Object.values(builtInIds).includes(descriptor.id) ? descriptor.id : undefined);
}
